import { createSvgIcon } from '@mui/material/utils';

export const DeviasChevronRight = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6001 16.7999L14.4001 12L9.6001 7.19995"
      stroke="#3F455A"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>, 'DeviasChevronRight'
);
